function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
import dayjs from 'dayjs';
import { formatMonthLabel } from './format-month-label/format-month-label.js';
import { isMonthInRange } from '../MonthPicker/is-month-in-range/is-month-in-range.js';
import { CalendarHeader } from '../CalendarHeader/CalendarHeader.js';
import { Month } from '../../Month/Month.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

function MonthsList(_a) {
  var _b = _a,
      amountOfMonths = _b.amountOfMonths,
      month = _b.month,
      locale = _b.locale,
      minDate = _b.minDate,
      maxDate = _b.maxDate,
      allowLevelChange = _b.allowLevelChange,
      size = _b.size,
      daysRefs = _b.daysRefs,
      onMonthChange = _b.onMonthChange,
      onNextLevel = _b.onNextLevel,
      _onDayKeyDown = _b.onDayKeyDown,
      classNames = _b.classNames,
      styles = _b.styles,
      _b$__staticSelector = _b.__staticSelector,
      __staticSelector = _b$__staticSelector === void 0 ? "MonthsList" : _b$__staticSelector,
      nextMonthLabel = _b.nextMonthLabel,
      previousMonthLabel = _b.previousMonthLabel,
      labelFormat = _b.labelFormat,
      weekdayLabelFormat = _b.weekdayLabelFormat,
      preventFocus = _b.preventFocus,
      renderDay = _b.renderDay,
      others = __objRest(_b, ["amountOfMonths", "month", "locale", "minDate", "maxDate", "allowLevelChange", "size", "daysRefs", "onMonthChange", "onNextLevel", "onDayKeyDown", "classNames", "styles", "__staticSelector", "nextMonthLabel", "previousMonthLabel", "labelFormat", "weekdayLabelFormat", "preventFocus", "renderDay"]);

  var nextMonth = dayjs(month).add(amountOfMonths, "months").toDate();
  var previousMonth = dayjs(month).subtract(1, "months").toDate();
  var months = Array(amountOfMonths).fill(0).map(function (_, index) {
    var monthDate = dayjs(month).add(index, "months").toDate();
    return /* @__PURE__ */React.createElement("div", {
      key: index
    }, /* @__PURE__ */React.createElement(CalendarHeader, {
      hasNext: index + 1 === amountOfMonths && isMonthInRange({
        date: nextMonth,
        minDate: minDate,
        maxDate: maxDate
      }),
      hasPrevious: index === 0 && isMonthInRange({
        date: previousMonth,
        minDate: minDate,
        maxDate: maxDate
      }),
      label: formatMonthLabel({
        month: monthDate,
        locale: locale,
        format: labelFormat
      }),
      onNext: function onNext() {
        return onMonthChange(dayjs(month).add(amountOfMonths, "months").toDate());
      },
      onPrevious: function onPrevious() {
        return onMonthChange(dayjs(month).subtract(amountOfMonths, "months").toDate());
      },
      onNextLevel: onNextLevel,
      nextLevelDisabled: !allowLevelChange,
      size: size,
      classNames: classNames,
      styles: styles,
      __staticSelector: __staticSelector,
      nextLabel: nextMonthLabel,
      previousLabel: previousMonthLabel,
      preventLevelFocus: index > 0,
      preventFocus: preventFocus
    }), /* @__PURE__ */React.createElement(Month, __spreadValues({
      month: monthDate,
      daysRefs: daysRefs.current[index],
      onDayKeyDown: function onDayKeyDown() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _onDayKeyDown.apply(void 0, [index].concat(args));
      },
      size: size,
      minDate: minDate,
      maxDate: maxDate,
      classNames: classNames,
      styles: styles,
      __staticSelector: __staticSelector,
      locale: locale,
      focusable: index === 0,
      preventFocus: preventFocus,
      renderDay: renderDay,
      weekdayLabelFormat: weekdayLabelFormat
    }, others)));
  });
  return /* @__PURE__ */React.createElement(React.Fragment, null, months);
}

MonthsList.displayName = "@mantine/dates/MonthsList";
export { MonthsList };